import { AuroraBackground } from './AuroraBackground';
import './PageHero.css';

const API_URL = process.env.REACT_APP_API_URL;

export function PageHero({ eyebrow, title, subtitle, imageUrl, children }) {
  return (
    <section className="page-hero">
      {imageUrl && (
        <div className="page-hero__bg">
          <img src={`${API_URL}${imageUrl}`} alt="" />
        </div>
      )}
      {imageUrl && <div className="page-hero__overlay" />}
      <AuroraBackground tone="dark" />
      <div className="container page-hero__inner">
        {eyebrow && <p className="page-hero__eyebrow hero-reveal hero-reveal--1">{eyebrow}</p>}
        <h1 className="hero-reveal hero-reveal--2">{title}</h1>
        {subtitle && <p className="page-hero__subtitle hero-reveal hero-reveal--3">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
